import { ReactNode } from 'react'

import { Badge, BadgeProps } from '@tribeplatform/react-ui-kit/Badge'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

interface Props {
  message?: string
  text?: ReactNode
  variant?: BadgeProps['variant']
}

export const BlockBadge = ({ message, text, variant }: Props) => {
  return (
    <Tooltip disabled={!message}>
      <Tooltip.Trigger asChild>
        <Badge size="sm" variant={variant}>
          {text}
        </Badge>
      </Tooltip.Trigger>
      <Tooltip.Panel>{message}</Tooltip.Panel>
    </Tooltip>
  )
}
